import { fetcher } from '@/src/general/utilities/fetcher'
import { Cookie } from '@/src/general/utils/cookies/Cookie'

import { authTokenStorage } from '../utils/authTokenStorage'
import { useConnectRedirect } from './useConnectRedirect'

export const useConnectSuccess = (redirectTo?: string) => {
  const connectRedirect = useConnectRedirect({ redirectUrl: redirectTo })

  return ({ token }: { token: string }) => {
    fetcher.setXAuthToken(token)
    authTokenStorage.setToken(token)
    Cookie.set('jwtToken', token, 'oneYear')
    connectRedirect()
  }
}
